var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},_vm._l((_vm.relatedRPDocs),function(document,i){return _c('RelatedRPDocsSectionValueEditor',{key:document.id,attrs:{"index":i,"related-doc":document}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }